import { render } from "./ItTaxInformation.vue?vue&type=template&id=42323ae9"
import script from "./ItTaxInformation.vue?vue&type=script&lang=js"
export * from "./ItTaxInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__